import { combineReducers } from "redux";

import {
  askConstants
} from "../../actions/ask/index";
import {
  templatesConstants
} from "../../actions/ask/templates";
import {
  surveysConstants
} from "../../actions/ask/surveys";
import {
  answersConstants
} from "../../actions/ask/answers";
import {
  draftsConstants
} from "../../actions/ask/drafts";

function answer(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        detail: {},
        error: false,
        isGettingAnswer: false,
        isSavingAnswer: false
      }
      : state;
  switch (type) {
  case askConstants.GET_ANSWER_ASK_START:
    return {
      detail: {},
      error: false,
      isGettingAnswer: true,
      isSavingAnswer: false
    };
  case askConstants.GET_ANSWER_ASK_ERROR:
    return {
      detail: {},
      error: true,
      isGettingAnswer: false,
      isSavingAnswer: false
    };
  case askConstants.GET_ANSWER_ASK_SUCCESS:
    return {
      detail: payload,
      error: false,
      isGettingAnswer: false,
      isSavingAnswer: false
    };
  case answersConstants.SAVE_ANSWER_ASK_START:
  case answersConstants.SEND_ANSWER_ASK_START:
  case answersConstants.CREATE_SEND_ANSWER_ASK_START:
    return {
      detail: defaultState.detail,
      error: false,
      isGettingAnswer: false,
      isSavingAnswer: true
    };
  case answersConstants.SAVE_ANSWER_ASK_SUCCESS:
  case answersConstants.SEND_ANSWER_ASK_SUCCESS:
  case answersConstants.CREATE_SEND_ANSWER_ASK_SUCCESS:
  case answersConstants.SAVE_ANSWER_ASK_ERROR:
  case answersConstants.SEND_ANSWER_ASK_ERROR:
  case answersConstants.CREATE_SEND_ANSWER_ASK_ERROR:
    return {
      detail: defaultState.detail,
      error: false,
      isGettingAnswer: false,
      isSavingAnswer: false
    };
  default:
    return defaultState;
  }
}

function surveys(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        list: [],
        toRead: 0,
        toReadAccountant: 0,
        toSend: 0,
        toFill: 0,
        filled: 0,
        error: false,
        isGettingSurveys: false,
        isSavingSurvey: false,
        isLoaded: false,
        status: {
          started: false,
          ended: false,
          error: false
        }
      }
      : state;
  switch (type) {
  case surveysConstants.CREATE_SURVEY_ASK_START:
    return {
      ...state,
      isSavingSurvey: true
    };
  case surveysConstants.CREATE_SURVEY_ASK_SUCCESS:
  case surveysConstants.CREATE_SURVEY_ASK_ERROR:
    return {
      ...state,
      isSavingSurvey: false
    };
  case askConstants.GET_LIST_ASK_START:
    return {
      list: [],
      toRead: 0,
      toReadAccountant: 0,
      toSend: 0,
      toFill: 0,
      filled: 0,
      error: false,
      isGettingSurveys: true,
      isSavingSurvey: false,
      isLoaded: false,
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case askConstants.GET_LIST_ASK_ERROR:
    return {
      list: [],
      toRead: 0,
      toReadAccountant: 0,
      toSend: 0,
      toFill: 0,
      filled: 0,
      error: true,
      isGettingSurveys: false,
      isSavingSurvey: false,
      isLoaded: false,
      status: {
        started: false,
        ended: true,
        error: true
      }
    };
  case askConstants.GET_LIST_ASK_SUCCESS:
    let toRead = 0;
    let toReadAccountant = 0;
    let toSend = 0;
    let toFill = 0;
    let filled = 0;
    payload._embedded.surveys.map(survey => {
      if (!survey.itemViewedAt && survey.createdAt && !survey.completedAt) {
        toRead++;
      }
      if (!survey.managerViewedAt && survey.completedAt) {
        toReadAccountant++;
      }
      if (!survey.createdAt) {
        toSend++;
      }
      if (!survey.completedAt && survey.createdAt) {
        toFill++;
      }
      if (survey.completedAt) {
        filled++;
      }
      return null;
    });
    return {
      list: payload._embedded.surveys,
      toRead: toRead,
      toReadAccountant: toReadAccountant,
      toSend: toSend,
      toFill: toFill,
      filled: filled,
      error: false,
      isGettingSurveys: false,
      isSavingSurvey: false,
      isLoaded: true,
      status: {
        started: false,
        ended: true,
        error: false
      }
    };

  case surveysConstants.VIEWED_SURVEY_ASK_CHANGE_SUCCESS:
    let newSurveys = [];
    let newToRead = 0;
    let newToReadAccountant = 0;
    defaultState.list.map(survey => {
      if (survey.answerId === payload.id) {
        if (payload.accountant) {
          newSurveys.push({
            ...survey,
            managerViewedAt: payload.viewed ? new Date() : null
          });
        } else {
          newSurveys.push({
            ...survey,
            itemViewedAt: payload.viewed ? new Date() : null
          });
        }
      } else {
        newSurveys.push(survey);
      }
      return null;
    });
    newSurveys.map(survey => {
      if (!survey.itemViewedAt && survey.createdAt && !survey.completedAt) {
        newToRead++;
      }
      if (!survey.managerViewedAt && survey.completedAt) {
        newToReadAccountant++;
      }
      return null;
    });
    return {
      ...defaultState,
      list: newSurveys,
      toRead: newToRead,
      toReadAccountant: newToReadAccountant
    };
  case draftsConstants.DELETE_DRAFT_ASK_SUCCESS:
    let newSurveysD = [];
    defaultState.list.map(survey => {
      if (survey.id !== payload.id) {
        newSurveysD.push(survey);
      }
      return null;
    });
    return {
      ...defaultState,
      list: newSurveysD
    };
  default:
    return defaultState;
  }
}

function templates(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        list: [],
        detail: {},
        error: false,
        isGettingTemplates: false,
        isGettingTemplateDetail: false,
        isSavingTemplate: false
      }
      : state;
  switch (type) {
  case templatesConstants.CREATE_TEMPLATE_ASK_START:
    return {
      ...state,
      isSavingTemplate: true
    };
  case templatesConstants.CREATE_TEMPLATE_ASK_SUCCESS:
  case templatesConstants.CREATE_TEMPLATE_ASK_ERROR:
    return {
      ...state,
      isSavingTemplate: false
    };
  case templatesConstants.GET_TEMPLATES_ASK_START:
    return {
      list: [],
      detail: defaultState.detail,
      error: false,
      isGettingTemplates: true,
      isGettingTemplateDetail: defaultState.isGettingTemplateDetail
    };
  case templatesConstants.GET_TEMPLATES_ASK_ERROR:
    return {
      list: [],
      detail: defaultState.detail,
      error: true,
      isGettingTemplates: false,
      isGettingTemplateDetail: defaultState.isGettingTemplateDetail
    };
  case templatesConstants.GET_TEMPLATES_ASK_SUCCESS:
    return {
      list: payload._embedded.templates,
      detail: defaultState.detail,
      error: false,
      isGettingTemplates: false,
      isGettingTemplateDetail: defaultState.isGettingTemplateDetail
    };
  case templatesConstants.GET_TEMPLATE_DETAIL_ASK_START:
    return {
      list: defaultState.list,
      detail: {},
      error: false,
      isGettingTemplates: defaultState.isGettingTemplates,
      isGettingTemplateDetail: true
    };
  case templatesConstants.GET_TEMPLATE_DETAIL_ASK_ERROR:
    return {
      list: defaultState.list,
      detail: {},
      error: true,
      isGettingTemplates: defaultState.isGettingTemplates,
      isGettingTemplateDetail: false
    };
  case templatesConstants.GET_TEMPLATE_DETAIL_ASK_SUCCESS:
    return {
      list: defaultState.list,
      detail: payload,
      error: false,
      isGettingTemplates: defaultState.isGettingTemplates,
      isGettingTemplateDetail: false
    };
  case templatesConstants.DELETE_TEMPLATE_ASK_SUCCESS:
    let newTemplatesD = [];
    defaultState.list.map(template => {
      if (template.templateId !== payload.id) {
        newTemplatesD.push(template);
      }
      return null;
    });
    return {
      ...defaultState,
      list: newTemplatesD
    };
  default:
    return defaultState;
  }
}

function drafts(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        list: [],
        detail: {},
        toRead: 0,
        toReadAccountant: 0,
        toSend: 0,
        toFill: 0,
        filled: 0,
        error: false,
        isGettingDraftsSurveys: false,
        isSavingDraftsSurvey: false,
        isGettingDraftDetail: false
      }
      : state;
  switch (type) {
  case draftsConstants.GET_DRAFT_ASK_START:
    return {
      ...state,
      isGettingDraftDetail: true
    };
  case draftsConstants.GET_DRAFT_ASK_SUCCESS:
    return {
      ...state,
      detail: payload,
      isGettingDraftDetail: false
    };
  case draftsConstants.GET_DRAFT_ASK_ERROR:
    return {
      ...state,
      isGettingDraftDetail: false
    };
    /* case surveysConstants.CREATE_SURVEY_ASK_START:
      return {
        ...state,
        isSavingDraftsSurvey: true
      }
    case surveysConstants.CREATE_SURVEY_ASK_SUCCESS:
    case surveysConstants.CREATE_SURVEY_ASK_ERROR:
      return {
        ...state,
        isSavingSurvey: false
      }*/
    /* case GET_LIST_DRAFTS_ASK_START:
      return {
        list: [],
        toRead: 0,
        toReadAccountant: 0,
        toSend: 0,
        toFill: 0,
        filled: 0,
        error: false,
        isGettingDraftsSurveys: true,
        isSavingDraftsSurvey: false
      };
    case GET_LIST_DRAFTS_ASK_ERROR:
      return {
        list: [],
        toRead: 0,
        toReadAccountant: 0,
        toSend: 0,
        toFill: 0,
        filled: 0,
        error: true,
        isGettingDraftsSurveys: false,
        isSavingDraftsSurvey: false
      };
    case GET_LIST_DRAFTS_ASK_SUCCESS:
      let toRead = 0;
      let toReadAccountant = 0;
      let toSend = 0;
      let toFill = 0;
      let filled = 0;
      payload._embedded.surveys.map(survey => {
        if (!survey.itemViewedAt && survey.createdAt && !survey.completedAt) {
          toRead++;
        }
        if (!survey.managerViewedAt && survey.completedAt) {
          toReadAccountant++;
        }
        if (!survey.createdAt){
          toSend ++;
        }
        if (!survey.completedAt && survey.createdAt){
          toFill ++;
        }
        if (survey.completedAt){
          filled ++;
        }
        return null;
      });
      return {
        list: payload._embedded.surveys,
        toRead: toRead,
        toReadAccountant: toReadAccountant,
        toSend: toSend,
        toFill: toFill,
        filled: filled,
        error: false,
        isGettingDraftsSurveys: false,
        isSavingDraftsSurvey: false
      }; */
  default:
    return defaultState;
  }
}

function categories(state, { type, payload }) {
  const defaultState =
    typeof state === "undefined"
      ? {
        isGettingCategories: false,
        list: [],
        error: ""
      }
      : state;

  switch (type) {
  case surveysConstants.GET_CATEGORY_ASK_START:
    return {
      ...defaultState,
      isGettingCategories: true
    };
  case surveysConstants.GET_CATEGORY_ASK_SUCCESS:
    return {
      ...defaultState,
      isGettingCategories: false,
      list: payload._embedded.categories
    };
  case surveysConstants.GET_CATEGORY_ASK_ERROR:
    return {
      ...defaultState,
      isGettingCategories: false,
      error: payload
    };
  default:
    return defaultState;
  }
}

function attachment(state, { type, payload }) {
  const defaultState =
    typeof state === "undefined"
      ? {
        isGettingDocument: false,
        isGettingPreview: false,
        isMovingDocument: false,
        document: {},
        preview: "",
        error: ""
      }
      : state;

  switch (type) {
  case answersConstants.MOVE_ANSWER_DOCUMENT_START:
    return {
      ...defaultState,
      isMovingDocument: payload.id
    };
  case answersConstants.MOVE_ANSWER_DOCUMENT_SUCCESS:
    return {
      ...defaultState,
      isMovingDocument: false
    };
  case answersConstants.MOVE_ANSWER_DOCUMENT_ERROR:
    return {
      ...defaultState,
      isMovingDocument: false,
      error: payload
    };
  case answersConstants.GET_ANSWER_DOCUMENT_DETAIL_START:
    return {
      ...defaultState,
      isGettingDocument: true
    };
  case answersConstants.GET_ANSWER_DOCUMENT_PREVIEW_START:
    return {
      ...defaultState,
      isGettingPreview: true
    };
  case answersConstants.GET_ANSWER_DOCUMENT_DETAIL_SUCCESS:
    return {
      ...defaultState,
      isGettingDocument: false,
      document: payload
    };
  case answersConstants.GET_ANSWER_DOCUMENT_PREVIEW_SUCCESS:
    return {
      ...defaultState,
      isGettingPreview: false,
      preview: payload.content || null
    };
  case answersConstants.GET_ANSWER_DOCUMENT_DETAIL_ERROR:
    return {
      ...defaultState,
      isGettingDocument: false,
      error: payload
    };
  case answersConstants.GET_ANSWER_DOCUMENT_PREVIEW_ERROR:
    return {
      ...defaultState,
      isGettingPreview: false,
      error: payload
    };
  case answersConstants.CLEAR_ANSWER_ATTACHMENT:
    return {
      isGettingDocument: false,
      isGettingPreview: false,
      isMovingDocument: false,
      document: {},
      preview: "",
      error: ""
    };
  default:
    return defaultState;
  }
}

function communityTemplates(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        templatesList: [],
        error: false,
        isGettingCommunityTemplates: false
      }
      : state;
  switch (type) {
  case askConstants.GET_COMMUNITY_TEMPLATES_LIST_START:
    return {
      templatesList: [],
      error: false,
      isGettingCommunityTemplates: true
    };
  case askConstants.GET_COMMUNITY_TEMPLATES_LIST_SUCCESS:
    return {
      templatesList: payload,
      error: false,
      isGettingCommunityTemplates: false
    };
  case askConstants.GET_COMMUNITY_TEMPLATES_LIST_ERROR:
    return {
      templatesList: [],
      error: true,
      isGettingCommunityTemplates: false
    };
  default:
    return defaultState;
  }
}

function communityTemplateDetails(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        templateDetails: {},
        error: false,
        isGettingCommunityTemplateDetails: false
      }
      : state;
  switch (type) {
  case askConstants.GET_COMMUNITY_TEMPLATE_DETAILS_START:
    return {
      templateDetails: {},
      error: false,
      isGettingCommunityTemplateDetails: true
    };
  case askConstants.GET_COMMUNITY_TEMPLATE_DETAILS_SUCCESS:
    return {
      templateDetails: payload,
      error: false,
      isGettingCommunityTemplateDetails: false
    };
  case askConstants.GET_COMMUNITY_TEMPLATE_DETAILS_ERROR:
    return {
      templateDetails: {},
      error: true,
      isGettingCommunityTemplateDetails: false
    };
  default:
    return defaultState;
  }
}

function saveCommunityTemplateState(state, { type, payload}) {
  let defaultState =
    typeof state === "undefined"
      ? {
        ended: false,
        error: false,
        isSavingCommunityTemplateDetails: false
      }
      : state;
  switch (type) {
  case askConstants.SAVE_COMMUNITY_TEMPLATE_START:
    return {
      ended: false,
      error: false,
      isSavingCommunityTemplateDetails: true
    };
  case askConstants.SAVE_COMMUNITY_TEMPLATE_SUCCESS:
    return {
      ended: true,
      error: false,
      isSavingCommunityTemplateDetails: false
    };
  case askConstants.SAVE_COMMUNITY_TEMPLATE_ERROR:
    return {
      ended: true,
      error: true,
      isSavingCommunityTemplateDetails: false
    };
  default:
    return defaultState;
  }
}

export const askReducer = combineReducers({
  surveys,
  answer,
  templates,
  drafts,
  categories,
  attachment,
  communityTemplates,
  communityTemplateDetails,
  saveCommunityTemplateState
});

export default askReducer;